/*******************************************************
 * Copyright (C) BoostCommerce.net
 *
 * This file is part of commercial BoostCommerce.net projects.
 *
 * This file can not be copied and/or distributed without the express
 * permission of BoostCommerce.net
 *
 * @Date:   2019-09-20 07:47:45
 *
 *******************************************************/
// @flow

import _ from 'lodash';
import React, { Component } from 'react';
import { Card, Tabs } from '@shopify/polaris';
import { withI18n, WithI18nProps } from '@shopify/react-i18n';

import SearchTab from 'src/components/containers/tools/translation/tabs/search-tab';
import CommonTab from './common-tab';
import RecommendationTab from './recommendation-tab/recommendation-tab';
import { TAB_V1, TAB_V2, RECOMMENDATION_TAB } from 'src/constants/translation';

type Props = {
  selectedLocale: Object,
  inputSearchText: string,
  handleTabChange: Function,
  translationFields: Object,
  primaryLocale: string,
  recommendation: Object,
  themeSetupV3: boolean
};
type ComposedProps = Props & WithI18nProps;

type State = {
  selected: number
};

class ContentTabs extends Component<ComposedProps, State> {
  state = {
    selected: 0
  };

  componentDidMount() {
    // Check tabs
    const { selectedTab } = this.props;
    this.setState({ selected: selectedTab });
  }

  componentWillReceiveProps(nextProps) {
    const { inputSearchText: prevInputSearchText } = this.props;
    const { inputSearchText } = nextProps;
    const { selected } = this.state;

    // Change search text => Back to Search result tab
    if (inputSearchText && inputSearchText !== prevInputSearchText) {
      this.setState({ selected: 0 });
    }

    if (_.isEmpty(inputSearchText) && inputSearchText !== prevInputSearchText && selected > 0) {
      this.setState({ selected: selected - 1 });
    }
  }

  /**
   * Get component by theme setup v3
   * @returns 
   */
  getComponentByThemeSetup = () => {
    const {
      i18n,
      themeSetupV3,
      primaryLocale,
      recommendation,
      selectedLocale,
      translationFields = {}
    } = this.props;

    const activeRecommendation = _.get(recommendation, 'status', 'inactive');
    const enableRecommendation = _.get(recommendation, 'settings.enable', false);

    const hideRecommendation = !(activeRecommendation && enableRecommendation);

    let tabItems = _.cloneDeep(themeSetupV3 ? TAB_V2 : TAB_V1);
    if (hideRecommendation) tabItems = _.filter(tabItems, item => item.name !== RECOMMENDATION_TAB);

    return {
      tabs: _.map(tabItems, item => ({ ...item, content: i18n.translate(item.content) })),
      tabComponents: _.map(tabItems, item => {
        if (item.name === RECOMMENDATION_TAB) {
          return (
            <RecommendationTab
              locale={selectedLocale}
              primaryLocale={primaryLocale}
              items={translationFields[item.name]}
            />
          );
        } else {
          return <CommonTab locale={selectedLocale} items={translationFields[item.name]} />;
        }
      })
    };
  };

  render() {
    const {
      i18n,
      selectedLocale,
      primaryLocale,
      inputSearchText,
      translationFields = {}
    } = this.props;

    const { tabs, tabComponents } = this.getComponentByThemeSetup();

    const tabsWithResult = _.clone(tabs);
    tabsWithResult.unshift({
      id: 'search',
      content: i18n.translate('AdminHTML.Translation.Search.title'),
      panelID: 'search-content'
    });
    const tabComponentsWithResult = _.clone(tabComponents);
    tabComponentsWithResult.unshift(
      <SearchTab
        inputSearchText={inputSearchText}
        translationFields={translationFields}
        locale={selectedLocale}
        primaryLocale={primaryLocale}
      />
    );

    const { selected } = this.state;

    return !_.isEmpty(inputSearchText) ? (
      <Tabs tabs={tabsWithResult} selected={selected} onSelect={this.handleTabChange}>
        <div className="tabContent">
          <Card.Section>
            {tabComponentsWithResult[selected]}
            <div style={{ clear: 'both' }}></div>
          </Card.Section>
        </div>
      </Tabs>
    ) : (
      <Tabs tabs={tabs} selected={selected} onSelect={this.handleTabChange}>
        <div className="tabContent">
          <Card.Section>
            {tabComponents[selected]}
            <div style={{ clear: 'both' }}></div>
          </Card.Section>
        </div>
      </Tabs>
    );
  }

  // Tab change event handler
  handleTabChange = selectedTabIndex => {
    // const { inputSearchText } = this.props;
    // if (!_.isEmpty(inputSearchText)) {
    //   selectedTabIndex -= 1;
    // }
    this.setState({ selected: selectedTabIndex });
  };
}

export default withI18n()(ContentTabs);
